export default __webpack_public_path__ + "static/media/catstevens.3639f684.jpeg";